// CATS + MOTIF + colorHex — ยกจาก prototype (อนุมัติแล้ว) · PRODUCTS seed จาก /seed
export { PRODUCTS } from '../../seed/products.mjs';
export { COUNTRIES, zoneOf } from '../../seed/shipping.mjs';

export const CONFIG = {
  domain: process.env.BB_DOMAIN || 'barebones.co.th',
  email: process.env.BB_EMAIL || 'contact@barebones.co.th',
  freeShipThreshold: 5000, // แสดงผลเท่านั้น — ค่าจริงฝั่ง Worker/DB (store.setting.free_ship_threshold)
};

export const CATS = {
  'power-light': { n: '01', t: 'Power & Light', d: 'ตะเกียง โคมไฟ vintage และไฟพกพา',
    mood: 'แสงอบอุ่นแบบไส้หลอดคลาสสิก สำหรับค่ำคืนกลางแจ้งและมุมโปรดในบ้าน',
    g1: '#2b3a52', g2: '#516b8f', glow: '#f0d9b0', tk: '#f4f1ea', mk: '#cfe0f2', motif: 'lamp' },
  'tools': { n: '02', t: 'Tools', d: 'มีด เครื่องมือสวน และอุปกรณ์ไฟ',
    mood: 'เหล็กกล้าเคลือบและ accent ทองแดง เครื่องมือที่ออกแบบมาให้ใช้ได้ทั้งชีวิต',
    g1: '#3a4038', g2: '#5d6553', glow: '#c98b5a', tk: '#f2f0e8', mk: '#dfe4d4', motif: 'blade' },
  'cook-dine': { n: '03', t: 'Cook & Dine', d: 'cast iron เตาย่าง และของใช้บนโต๊ะ',
    mood: 'จาก open-fire ถึงโต๊ะอาหาร — cast iron ที่ยิ่งใช้ยิ่งสวย',
    g1: '#3a2a22', g2: '#7a4a34', glow: '#f0c07a', tk: '#f5ede4', mk: '#f2cfae', motif: 'flame' },
  'store-carry': { n: '04', t: 'Store & Carry', d: 'เก้าอี้ โต๊ะ และกระเป๋าผ้าใบ',
    mood: 'เฟอร์นิเจอร์พับได้และกระเป๋าผ้าใบทนทาน สำหรับพกพาและจัดเก็บ',
    g1: '#4a4636', g2: '#6b6449', glow: '#c9b98a', tk: '#f3f0e6', mk: '#e0dcc9', motif: 'bag' },
};

export const MOTIF = {
  lamp: '<svg class="motif" viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="2"><path d="M38 20h24l6 12H32l6-12Z"/><path d="M34 32h32v42a8 8 0 0 1-8 8H42a8 8 0 0 1-8-8V32Z"/><path d="M44 46h12v20H44z"/><path d="M50 8v12"/></svg>',
  blade: '<svg class="motif" viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 70c30-6 46-24 60-52 4 14-2 40-24 54-14 9-30 6-36-2Z"/><path d="M30 78l-10 10"/><path d="M40 74l6 6"/></svg>',
  flame: '<svg class="motif" viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="2"><path d="M50 14c10 14 22 22 22 38a22 22 0 0 1-44 0c0-8 4-14 8-18 2 6 6 8 8 6 2-2-2-10-2-16 0-4 4-8 8-10Z"/></svg>',
  bag: '<svg class="motif" viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="2"><path d="M28 38h44l-4 44H32l-4-44Z"/><path d="M40 38a10 10 0 0 1 20 0"/><path d="M34 30h32"/></svg>',
};

export const colorHex = (c) => ({
  'Slate Gray': '#748cab', 'Olive Drab': '#5c6349', 'Vintage White': '#eee7d8',
  'Antique Bronze': '#8a6d4b', 'Copper': '#b5713f', 'Ocean Blue': '#3f6484',
  'Dusty Yellow': '#c7a84e', 'Tumbled Steel': '#9aa0a6', 'Brass': '#b08d57',
  'Terracotta': '#b5674a', 'Black': '#2a2a2a', 'Walnut': '#5b4632',
}[c] || '#c9c1b3');
